import { CheckIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import Spinner from "@/common/Spinner";

const CompletingPayroll = ({ generatingReports }) => {
	return (
		<div className="block text-center">
			<div id="all-done">
				<div className="block-content block-content-full">
					<span className="item item-circle bg-success-light">
						<CheckIcon style={{ height: "1.5em", marginTop: 9 }} />
					</span>
				</div>
				<div className="main">
					<h1 className="font-w700 text-center">All done!</h1>
					<p className="text-center">Congratulations on completing this payroll!</p>
				</div>
				{generatingReports && (
					<div className="block buttons center">
						<p className="text-center">We're generating your reports - with you shortly!</p>
						<p className="text-center">
							<Spinner
								style={{ width: "4rem", height: "4rem", verticalAlign: "middle", marginTop: 20 }}
								className="animate-spin -ml-1 mr-3 text-success"
							/>
						</p>
					</div>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {

	return {
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CompletingPayroll);
